import React from 'react';
import { useTheme } from '../context/ThemeContext';
import { Button } from './ui/button';
import { Sun, Moon } from 'lucide-react';

export const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggleTheme}
      className="w-9 h-9 rounded-lg"
      data-testid="theme-toggle"
    >
      {theme === 'light' ? (
        <Moon className="w-5 h-5 text-slate-600 dark:text-slate-300" />
      ) : (
        <Sun className="w-5 h-5 text-yellow-500" />
      )}
      <span className="sr-only">Toggle theme</span>
    </Button>
  );
};
